const ID_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
export function randomString(length) {
    let randomText = '';
    for (let i = 0; i < length; i++) {
        randomText += ID_CHARS[Math.floor(Math.random() * ID_CHARS.length)];
    }
    return randomText;
}
export function removePrefixIfExists(value, prefix) {
    if (value.substring(0, 3) === prefix) {
        return value.substring(3);
    }
    return value;
}
//# sourceMappingURL=strings.js.map